<template>
    <el-container>
    <el-header style="height: 120px;">
      <div class="all-search">
      <div class="search-input" >
        <el-input v-model="companyname" placeholder="公司名称或用户名或手机号码" ></el-input>
      </div>
      <div class="search-button" >
        <el-button type="primary"  @click="search">搜索</el-button>
      </div>
      <div class="search-reset" >
        <el-button type="primary"  @click="searchreset">重置</el-button>
      </div>
      </div>
      <div class="addcss" >
        <el-button type="primary"   @click="batchdelete">批量删除</el-button>
      </div>
      <div class="addcss" >
        <el-button type="primary"   @click="addUserAccount">增加</el-button>
      </div>
      <div class="status-filter-select">
<!--        @change=""-->
        <el-select v-model="status" @change="filterByStatus" placeholder="请选择状态">
          <el-option label="全部" value=""></el-option>
          <el-option label="待审核" value="0"></el-option>
          <el-option label="已通过" value="1"></el-option>
          <el-option label="未通过" value="2"></el-option>
        </el-select>
      </div>
    </el-header>
<!--      style="width: auto"-->
    <el-main style="line-height:50px;">
      <div class="tabledata">
        <el-table :data="filteredUsers"  ref="multipleTable"  highlight-selection-row  @selection-change="handleSelect" row-key="id" style="width: auto;">
          <el-table-column
            type="selection"
            v-if="showflag">
          </el-table-column>
<!--        <el-table-column type="index"  :index="1 + this.queryInfo.pageSize * (this.queryInfo.pageNum - 1)"  label="序号" >-->
<!--        </el-table-column>-->
          <el-table-column
            width="100px"
            prop="parentIndex"
            label="序号"
            align="left">
          </el-table-column>
        <el-table-column prop="companyname" label="公司名称"  >
        </el-table-column>
        <el-table-column prop="account" label="用户名">
        </el-table-column>
<!--        <el-table-column prop="password" label="密码" >-->
<!--        </el-table-column>-->
        <el-table-column prop="phonenumber" label="手机号码" >
        </el-table-column>
        <el-table-column prop="realname" label="备注" >
        </el-table-column>
          <el-table-column prop="testAccount" label="测试账号" >
            <template slot-scope="scope">
              {{ scope.row.testAccount == true ? '是' : '否' }}
            </template>
          </el-table-column>
        <el-table-column prop="role" label="用户角色" >
        </el-table-column>
          <el-table-column label="账户类型">
            <template slot-scope="scope">
              {{ scope.row.accounttype == '1' ? '清洗喷枪' : '消防吊桶' }}
            </template>
          </el-table-column>
        <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === '2'
                ? 'danger'
               : (scope.row.status === '0' ? 'warning' : 'success')">

                {{ scope.row.status === '2'
                ? '未通过'
                : (scope.row.status === '0' ? '待审核' : '已通过') }}

              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="审核" >
            <template slot-scope="scope">
              <div v-if="scope.row.status === '0'">
                <el-link type="success" @click="auditUser(scope.row.id, '1')" style="margin-right: 10px;">通过</el-link>
                <el-link type="danger" @click="auditUser(scope.row.id, '2')">不通过</el-link>
              </div>
              <span v-else>
                -
            </span>
            </template>
          </el-table-column>
          <el-table-column prop="resetPassword" label="重置密码" >
            <template slot-scope="scope">
              <el-link  @click="resetPassword(scope.row.id)" style="color: #3B82F6">重置密码</el-link>
            </template>
          </el-table-column>
        <el-table-column  label="操作"  >
          <template slot-scope="scope">
          <el-link  @click="editUser(scope.row)" style="color: #3B82F6">编辑</el-link>
          <el-link  @click="deleteUser(scope.row.id)">删除</el-link>
          </template>
        </el-table-column>

      </el-table>
      </div>
    </el-main>
    <el-footer><el-pagination background layout="sizes,total,prev, pager, next"  :page-sizes="[10, 15, 20, 25]"  :page-size="this.queryInfo.pageSize"  @size-change="handleSizeChange"  @current-change="changePage" :total="this.total" :current-page="this.queryInfo.pageNum">
    </el-pagination></el-footer>
    </el-container>
</template>

<script>
// import router from '../../router/index'
import axios from '../../../utils/request'
export default {
  data () {
    return {
      companyname: '',
      filteredUsers: [],
      dialogFormVisible: false,
      selectRowsdata: [],
      queryInfo: {
        pageSize: 10,
        pageNum: 1
      },
      total: 0,
      formData: {
      },
      showflag: false,
      multipleSelection: [],
      disableflag: true,
      status: ''
      // statusFilter: ''
    }
  },

  // components: {
  //   table
  // },
  created: function () {
    this.methodToTrigger()
    console.log(this.filteredUsers)
  },
  methods: {
    methodToTrigger: function () {
      axios.get(`/data/account/status?companyname=${this.companyname}&status=${this.status}&pageNum=${this.queryInfo.pageNum}&pageSize=${this.queryInfo.pageSize}`).then(res => {
        this.filteredUsers = res.data.list
        this.total = res.data.total
        this.setParentIndex(this.filteredUsers, this.queryInfo.pageNum)
      }).catch(error => {
        console.log('error', error)
      })
    },
    filterByStatus: function (val) {
      this.$forceUpdate()
      this.status = val
      axios.get(`/data/account/status?companyname=${this.companyname}&status=${val}&pageNum=${this.queryInfo.pageNum}&pageSize=${this.queryInfo.pageSize}`).then(res => {
        this.filteredUsers = res.data.list
        this.total = res.data.total
        this.setParentIndex(this.filteredUsers, this.queryInfo.pageNum)
      }).catch(error => {
        console.log('error', error)
      })
    },
    auditUser: function (id, val) {
      axios.get(`/data/account/updatestatus?id=${id}&status=${val}`).then(res => {
        this.methodToTrigger()
      })
    },
    handleSizeChange: function (val) {
      this.queryInfo.pageSize = val
      this.methodToTrigger()
    },
    addUserAccount: function () {
      this.$router.push({path: '/data/addaccount',
        query: {
          disableflag: false
        }})
    },
    search: function () {
      this.queryInfo.pageNum = 1
      this.queryInfo.pageSize = 10
      this.methodToTrigger()
    },
    searchreset: function () {
      this.companyname = ''
      this.methodToTrigger()
    },
    changePage: function (val) {
      var that = this
      this.queryInfo.pageNum = val
      axios.get(`/data/account/status?companyname=${this.companyname}&status=${this.status}&pageNum=${this.queryInfo.pageNum}&pageSize=${this.queryInfo.pageSize}`)
        .then(function (res) {
          that.filteredUsers = res.data.list
          that.total = res.data.total
          that.setParentIndex(that.filteredUsers, that.queryInfo.pageNum)
        }).catch(error => {
          console.log('111111', error)
        })
    },
    deleteUser: function (val) {
      var that = this
      that.$confirm('删除该条记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.delete(`/data/account/delete?id=${val}`)
          .then(function (res) {
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
            that.methodToTrigger()
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    editUser: function (val) {
      console.log('val', val)
      this.$router.push({
        path: '/data/addaccount',
        query: {
          requesttype: 'update',
          companyname: val.companyname,
          account: val.account,
          password: val.password,
          phonenumber: val.phonenumber,
          realname: val.realname,
          accounttype: val.accounttype,
          id: val.id,
          role: val.role,
          disableflag: true,
          testAccount: val.testAccount
        }
      })
    },
    handleSelect: function (val) {
      // this.selectedRows = selection // 更新选中数据
      // console.log('当前选中行：', row)
      // console.log('所有选中数据：', this.selectedRows)
      // this.selectRowsdata = this.selectedRows
      this.multipleSelection = val
      this.selectRowsdata = this.multipleSelection
      console.log(' this.selectRowsdata：', this.selectRowsdata)
    },
    batchdelete: function () {
      var that = this
      var ids = ''
      for (var i = 0; i < that.selectRowsdata.length; i++) {
        if (i !== that.selectRowsdata.length - 1) {
          ids = ids + that.selectRowsdata[i].id + ','
        } else {
          ids = ids + that.selectRowsdata[i].id
        }
      }
      if (that.showflag === false) {
        that.$refs.multipleTable.clearSelection()
        that.selectRowsdata = []
        that.ids = ''
      }

      if (ids !== '') {
        that.$confirm('删除这些记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          axios.delete(`/data/account/delids?ids=${ids}`)
            .then(function (res) {
              that.$message({
                type: 'success',
                message: '删除成功!'
              })
              // that.showflag = false
              that.selectRowsdata = []
              that.ids = ''
              that.methodToTrigger()
            })
        }).catch(() => {
          that.$message({
            type: 'info',
            message: '已取消删除'
          })
          that.$refs.multipleTable.clearSelection()
          that.selectRowsdata = []
          that.ids = ''
        })
      }
      this.showflag = !this.showflag
    },
    setParentIndex (list, pageNum) {
      list.forEach((item, index) => {
        item.parentIndex = index + 1 + this.queryInfo.pageSize * (pageNum - 1) + ''
        if (item.children && item.children.length > 0) {
          this._setParentIndex(item, item.parentIndex)
        }
      })
    },
    _setParentIndex (item, oldIndex) {
      if (item.children && item.children.length > 0) {
        item.children.forEach((subItem, i) => {
          subItem.parentIndex = oldIndex + '.' + (i + 1)
          // this._setParentIndex(subItem, subItem.parentIndex)
        })
      } else {
      }
    },
    resetPassword (val) {
      this.$confirm('把密码重置为admin123, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.get(`/data/account/resetPassword?id=${val}`)
          .then(function (res) {
            this.$message({
              type: 'success',
              message: '重置成功!'
            })
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消重置'
        })
      })
      // axios.get(`/data/account/resetPassword?id=${val}`).then(res => {
      //   console.log(res)
      //   if (res.code === 200) {
      //     this.$message.success('密码重置为 admin123 成功')
      //   }
      // })
    }
  }
}
</script>

<style scoped >
  .el-container {
    position:absolute;
    top:0;
    right:0;
    bottom:0;
    left:258px;
    height: 100%;
  }
  .el-header{
    /*background-color: #B3C0D1;*/
    color: #333;
    text-align: center;
    line-height: 60px;
    padding:0;
  }
  .el-footer {
    /*background-color: #B3C0D1;*/
    color: #333;
    text-align: center;
    line-height: 60px;
    height: 60px;
    padding:0;
  }

  .el-main {
    margin: 0px -43px;
    /*background-color: #B3C0D1;*/
    color: #333;
    text-align: center;
    line-height: 160px;
  }
  .addcss {
    float: right;
    margin-right: 10px;
  }
  .tabledata {
    height:70vh;
    margin-left: 20px;
  }

  .search-input{
    float:left;
    margin-left: 10px;
  }
  .search-button{
    float:left;
    margin-left: 10px;
  }
  .search-reset{
    float:left;
    margin-left: 10px;
  }
  .all-search{
    overflow: hidden;
    margin-left: -16px;
  }
  /* 新增：用于定位下拉框，使其独占一行 */
  .status-filter-select {
    float: left; /* 和按钮一样靠右 */
    margin-right: 10px;
    margin-top: 5px; /* 添加一些上边距，使其在按钮下方 */
  }
</style>



// WEBPACK FOOTER //
// src/components/table/account/useraccount.vue